import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    content: {
      marginTop: 17,
    },
    paper: {
      width: 400,
    },
    title: {
      backgroundColor: legacyColors.red,
      border: 'none',
    },
    titleText: {
      color: legacyColors.white,
    },
  };
};
